import {
  type CatalogItemTagVariant,
  CatalogItemTagVariants,
} from './CatalogItemTagVariant'
import { CatalogItemVendorBadgeSlots } from '../enums'

const BADGE_SLOT_VARIANTS = {
  [CatalogItemVendorBadgeSlots.PRIMARY]: CatalogItemTagVariants.STRONG,
  [CatalogItemVendorBadgeSlots.SUSTAINABILITY]: CatalogItemTagVariants.MUTED,
} as const

const INFO_BADGE_SLOTS: readonly (keyof typeof BADGE_SLOT_VARIANTS)[] = [
  CatalogItemVendorBadgeSlots.PRIMARY,
  CatalogItemVendorBadgeSlots.SUSTAINABILITY,
]

export const resolveInfoBadges = <TBadge extends { slot: string }>(
  vendorBadges: TBadge[] = []
): (TBadge & { variant: CatalogItemTagVariant })[] =>
  INFO_BADGE_SLOTS.map(
    (slot): Nullable<TBadge & { variant: CatalogItemTagVariant }> => {
      const badge = vendorBadges.find((candidate) => candidate.slot === slot)
      return badge ? { ...badge, variant: BADGE_SLOT_VARIANTS[slot] } : null
    }
  ).filter(
    (badge): badge is TBadge & { variant: CatalogItemTagVariant } =>
      badge !== null
  )
